
import Cookies from 'js-cookie'
import { mapState } from 'vuex'

import { LangEnum, baseShippingServices } from '@/utils/constBase'
import { isHiddenHeaderFn, isShowHeaderAndHideFooterFn } from '@/utils/utils'
import { removeAnalyticsListCookie } from '@/utils/cookieOperation'
import LOCALE from '@/utils/locale'
import { CHANNEL, STORAGE_KEY } from '@/reporter/config/const.js'
import { channelTrack } from '@/reporter/utils'
import {
  onCLS,
  onLCP,
  onTTFB,
  onFCP,
  onFID,
  onFP,
  onTTI,
} from '@/utils/webVitals'
import {
  WebCLS,
  WebLCP,
  WebTTFB,
  WebFCP,
  WebFID,
  WebFP,
  WebTTI,
} from '@/reporter/track/webVitals'

export default {
  data() {
    return {
      curScrollHeight: 0,
      scrollClass: '',
    }
  },
  head() {
    const site = this.$route?.params?.site || 'cn'
    const googleVerification = site === 'my'
        ? 'H1U626n-XU9Qi8jg4yyWFX9q28peO5RU5Jc2_VvPY8U'
        : 'Kf4L-HunLz2TFODWyqTyjSoieMYgE1Ub8HKCeeg6E70'

    return {
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.$t(`navs.commonKeywords`),
        },
        {
          hid: 'google-site-verification',
          name: 'google-site-verification',
          content: googleVerification,
        },
      ],
    }
  },
  computed: {
    ...mapState({
      isHome: (state) => state.isHome,
      isHdFtMobile: (state) => state.isHdFtMobile,
      locale: (state) => state.locale,
      loginToken: (state) => state.loginToken,
      isAgree: (state) => state.cookie_agree.agree,
      isMobile: (state) => state.isMobile,
      cookieBtnDisagree: (state) => state.cookie_btn_disagree,
      lang: (state) => state.lang,
    }),
    // 设置全局antd 语言
    configLocale() {
      return LOCALE[LangEnum[this.locale].code]
    },
    // 判断是否需要隐藏部分公共部分
    isHiddenHeader() {
      return isHiddenHeaderFn(this.$route, this.isMobile)
    },
    // 判断是否显示头部和隐藏底部
    isShowHeaderAndHideFooter() {
      return isShowHeaderAndHideFooterFn(this.$route, this.isMobile)
    },
    // KR 产品详情页：导航栏浮动覆盖在 banner 上方（同首页效果）
    isKrProductDetail() {
      return this.$store.state.site === 'kr' && (this.$route.path.includes('/productDetail')|| this.$route.path.includes('/koreasf')) && !this.isHdFtMobile
    },
    query() {
      if (this.$route) {
        return this.$route.query
      }
      return {}
    },
  },
  async created() {
    try {
      const { site } = this.$route.params
      // 获取物流服务菜单
      const res = await this.$API.product.getLogisticsServiceMenuApi()
      // 物流产品 ，增值服务，附加费 ,前端设置遍历顺序
      const sortArr = baseShippingServices[site] || baseShippingServices.default
      const productMenus = []
      const temp = res?.result || {}
      sortArr.forEach((key) => {
        let item = {}
        if (temp[key]) {
          item = { ...temp[key] }
          item.cname = temp[key].name
          item.path = `/product`
          item.name = key
          item.il8nName = ''
          item.hasNext = key === 'product' // 物流产品有4级菜单
          item.children = this.doMenuData(temp[key].children, key)
          item.params = { hash: key }
          productMenus.push({ ...item })
        }
      })
      this.$store.commit('addProductMenu', productMenus)
    } catch (error) {
      console.log(error)
    }

  },
  mounted() {
    const preference = Cookies.get('option.preference')
    // 开启了GDPR的分析类
    if (preference) {
      const obj = JSON.parse(preference)
      if (!obj.analytics) {
        removeAnalyticsListCookie()
      } else {
        // 添加百度埋点
        const hm = document.createElement('script')
        hm.src = 'https://hm.baidu.com/hm.js?3bb0f07b0490eb4831bd081b5e06c9d4'
        const s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(hm, s)
      }
    } else {
      removeAnalyticsListCookie()
    }
    this.initTrack()
    onFP(WebFP)
    onTTI(WebTTI)
    onCLS(WebCLS)
    onLCP(WebLCP)
    onTTFB(WebTTFB)
    onFCP(WebFCP)
    onFID(WebFID)
  },
  // 移除滚动条监听事件
  destroyed() {},
  methods: {
    doMenuData(children = [], rootCode) {
      const list =
        children?.map((i) => {
          const item = {}
          item.cname = i.name
          // CMS 配置的产品类型（1快递/2电商/4供应链/5货代），首页产品区按它匹配接口产品
          item.productType = i.productType
          item.path = i.code ? `/product/${i.code}` : ''
          item.name = i.code || i.name
          item.il8nName = ''
          i.children && (item.children = this.doMenuData(i.children, rootCode))
          item.params = i.code ? { query: { isProduct: rootCode } } : {}
          item.aliasName = i.aliasName
          item.sort = i.sort
          return item
        }) || []
      // 按 CMS 配置的 sort 升序展示；未配置 sort 的保持接口返回顺序垫底
      return list.sort((a, b) => {
        const sa = Number(a.sort)
        const sb = Number(b.sort)
        const hasA = a.sort !== null && a.sort !== undefined && !isNaN(sa)
        const hasB = b.sort !== null && b.sort !== undefined && !isNaN(sb)
        if (hasA && hasB) return sa - sb
        if (hasA) return -1
        if (hasB) return 1
        return 0
      })
    },
    initTrack() {
      const channel = this.getChannel()
      if (channel) {
        channelTrack(channel)
        this.setChannel(channel)
      }
    },
    findAttr(query, object) {
      const sysCode = query.sysCode
      return sysCode || false
    },
    getChannel() {
      const channel = sessionStorage.getItem(STORAGE_KEY.channel)
      return channel || this.findAttr(this.query, CHANNEL)
    },
    setChannel(channel) {
      sessionStorage.setItem(STORAGE_KEY.channel, channel)
    },
  },
}
